import { useEffect } from 'react';

export default function Unlock() {
  useEffect(() => localStorage.setItem('userInfo', ''), []);
  return null;
}
